/**
 * Identity string for the current entity-list view + filters, used to detect
 * when a view/filter switch has actually taken effect.
 *
 * The entity list routes show a loading skeleton from the moment a view tab or
 * filter is clicked (a synchronous flag) until the URL navigation commits and
 * the list query re-keys and settles. That flag is cleared by comparing this
 * identity against the value captured at click time.
 *
 * The view id MUST be included. Dynamic views carry their filter in the URL and
 * set no `staticViewId`, so two different views can share a filter (e.g.
 * "Architects" and "Architects New", both account_type=architect). Keying only
 * on the filter would make a switch between them look unchanged, so the flag
 * would never clear and the skeleton would stick forever (no refetch, nothing in
 * the console). Keying on the view id as well makes every real switch register.
 */
export function listTransitionKey(urlViewId: string | null, filterKey: string): string {
  return `${urlViewId ?? ''}|${filterKey}`;
}
